<template>
  <div class="ywzs_box">
    <div class="in_abtCnt">
      <!-- title start -->
      <div class="wow bounceIn animated ywzs_title">
        <span>
          <img class="ywzs_img1" src="@/assets/images/yw_ico_1.png" />
          {{ lange == "ch" ? yewujishao.zTitle.ch : yewujishao.zTitle.en }}
          <img class="ywzs_img2" src="@/assets/images/yw_ico_1.png" />
        </span>
      </div>
      <!-- title end -->
      <div class="ywzs_js">
        {{ lange == "ch" ? yewujishao.zTextL.ch : yewujishao.zTextL.en }}
      </div>

      <!-- -->
      <div class="ywzs_zs">
        <div
          class="wow bounceInRight animated ywzs_ls"
          v-for="(item, index) in yewujishao.list"
          :key="index"
          :data-wow-delay="
            index == 0 ? '0.2s' : index == 1 ? '0.6' : index == 2 ? '0.9' : ''
          "
          @click="clickShow"
        >
          <img id="yImg_1" class="yImg" :src="item.bgimg" />
          <img id="yImg_2" class="yImg1" :src="item.bgimg2" />
          <div class="ywzs_ls_cnt">
            <div class="y_tit">
              <span>{{ lange == "ch" ? item.title.ch : item.title.en }}</span>
              <!-- <img src="@/assets/images/ina_ico_2.png" /> -->
            </div>
            <span class="y_txt">{{
              lange == "ch" ? item.txt.ch : item.txt.en
            }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="btn">
        <span>{{ lange == "ch" ? yewujishao.btn.ch : yewujishao.btn.en }}</span>
        <img class="x_1" src="@/assets/images/x_1.png" alt="" />
        <img class="x_2" src="@/assets/images/x_2.png" alt="" />
      </div> -->
      <!--<div class="btn_h">
        <i class="h_x_1"></i>
        <span class="h_x_2">{{
          lange == "ch" ? yewujishao.btn.ch : yewujishao.btn.en
        }}</span>
        <img class="h_x_3" src="@/assets/images/t_ico_1.png" alt="" />
      </div>-->
      <!--//  -->
    </div>
    <div class="division_i_s" style="width: 100%;  display: block"></div>

  </div>
</template>

<script>
import '@/assets/css/ConsultingLayer.css';
import { zixForm } from "@/api/index";
import { emailYz, checkPhone } from "@/utils/utils";
//知识产权代管服务
export default {
  name: "IntellectualProperty",
  components: {
  },
  computed: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      showTc: false,
      name: "",
      tel: "",
      emil: "",
      textareaTxt: "",
      yewujishao: {
        zTitle: {
          ch: "知识产权代管服务",
          en: "escrow service",
        },
        zTextL: {
          ch: "一站式知识产权代管服务就是为客户提供“管家式”知识产权服务。接受此项服务，相当于客户立即拥有了自己的知识产权部，相对于聘用专人，成本低，专业性强，服务更加全面。具体特色与优势如下：",
          en: 'One-stop intellectual property escrow service is to provide customers with "housekeeper" IP services. If a client enjoys this service, it is equivalent to having its own intellectual property department, which has the advantages of low cost, strong professionalism, and more comprehensive service than hiring personnel. The details are as follows:',
        },
        list: [
          {
            title: {
              ch: "专业水平高",
              en: "High professional level",
            },
            bgimg: require("../../../assets/images/ina_ico_3_1.png"),
            bgimg2: require("../../../assets/images/ina_ico_x1.png"),
            txt: {
              ch: "根据客户需求，设立和调配专业团队，没有具体专业限制，也不受负责人员流动影响。",
              en: "According to customer needs, professional teams are established and deployed without specific professional restrictions and are not affected by the flow of responsible personnel.",
            },
          },
          {
            title: {
              ch: "信息化水平高",
              en: "High informatization level",
            },
            bgimg: require("../../../assets/images/ina_ico_3_1.png"),
            bgimg2: require("../../../assets/images/ina_ico_x2.png"),
            txt: {
              ch: "根据客户需求，设立和调配专业团组，专业配备齐全，服务可持续。",
              en: "According to the needs of customers, set up and deploy professional groups with complete professional equipment and sustainable service.",
            },
          },
          {
            title: {
              ch: "费用合理优惠",
              en: "preferential fees",
            },
            bgimg: require("../../../assets/images/ina_ico_3_1.png"),
            bgimg2: require("../../../assets/images/ina_ico_x3.png"),
            txt: {
              ch: "费用优惠合理：采用会员制管家服务，普通会员每年仅收费3650元；免费向会员提供咨询服务，免费为客户建档；部分专项如商标申请，著作权登记，代缴费等可以先服务后收费，其他专项服务按照约定标准收费。",
              en: "Reasonable fee preference: membership butler service is adopted, and ordinary members only charge 3650 yuan per year; Provide free consulting services to members and file customers free of charge; ...",
            },
          },
        ],
        btn: {
          ch: "我要开通代管服务",
          en: "escrow service",
        },
      },
    };
  },
  created() {},
  methods:{
    clickShow() {
      if (this.showTc) {
        this.showTc = false;
      } else {
        this.showTc = true;
       }
    },
    clickHide() {
      this.showTc = false;
    },
    clickBtn() {
      if (this.yanzheng(this.name, "名字")) {
        return false;
      }
      if (this.yanzheng(this.tel, "电话")) {
        return false;
      }
      if (this.yanzheng(this.emil, "邮箱")) {
        return false;
      }
      if (this.yanzheng(this.textareaTxt, "描述")) {
        return false;
      }
      this.formApi();
      this.showTc = false;
    },
    formApi() {
      //咨询表单提交
      var data = {
        name: this.name,
        phoneNum: this.tel,
        email: this.emil,
        market: this.textareaTxt,
      };
      zixForm(data)
        .then((response) => {
          if (response.code == 0) {
            this.name = "";
            this.tel = "";
            this.emil = "";
            this.textareaTxt = "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    yanzheng(a, b) {
      if (a == "") {
        this.$message({
          showClose: true,
          message: b + "不能为空",
        });
        return true;
      }
      if (b == "邮箱") {
        if (!emailYz(a)) {
          this.$message({
            showClose: true,
            message: b + "格式不正确",
          });
          return true;
        }
      }
      if (b == "电话") {
        /*if (!checkPhone(a)) {
          this.$message({
            showClose: true,
            message: b + "格式不正确",
          });
          return true;
        }*/
      }
    },
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ywzs_box {
  width: 100%;
  display: block;
  background-color: #fff;
}
.in_abtCnt {
  width: 67.7%;
  min-height: 35px;
  display: block;
  margin: 0 auto;
  position: relative;
}
.ywzs_title {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 40px;
  color: #07566c;
  padding: 60px 0 30px 0;
  font-family: shsm, shsb, "Avenir", Helvetica, Arial, sans-serif;
}
.division_i_s{
  height: 80px;
}
.ywzs_title > span {
  display: inline-block;
  position: relative;
  padding: 0 23%;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ywzs_img1,
.ywzs_img2 {
  width: 30%;
  height: 2px;
  display: block;
  position: absolute;
  top: 50%;
}
.ywzs_img1 {
  left: -6%;
}
.ywzs_img2 {
  right: -6%;
}
.ywzs_js {
  width: 100%;
  display: block;
  font-size: 18px;
  color: #c28e33;
  text-align: center;
  margin: 0 0 70px 0;
  line-height: 38px;
}

.ywzs_zs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* padding: 80px 0 130px 0; */
  /* box-shadow: 0 0 30px rgba(0, 0, 0, 0.1); */
}
/*ls*/
.ywzs_ls {
  width: 33.33%;
  /* height: 380px; */
  display: block;
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: 50% 50%;
  background-color: #fff;
  position: relative;
}
.ywzs_ls:nth-child(1) {
  background-color: #f5f5f5;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 2;
}
.ywzs_ls:nth-child(3) {
  background-color: #f5f5f5;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.ywzs_ls_cnt {
  width: 80%;
  height: 80%;
  display: block;
  position: absolute;
  top: 10%;
  left: 10%;
}
.y_tit {
  width: 100%;
  display: block;
  position: relative;
  /* margin: 0 0 90% 0; */
}
.y_tit > img {
  width: 100%;
  display: block;
}
.y_tit > span {
  width: 100%;
  display: block;
  position: absolute;
  text-align: left;
  font-size: 20px;
  color: #333;
  top: 50%;
  left: 0;
  margin-top: 7%;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.y_txt {
  width: 100%;
  display: block;
  position: absolute;
  top: 30%;
  left: 0;
  bottom: 0;
  text-align: left;
  color: #c28e33;
  font-size: 16px;
  line-height: 30px;
  overflow: hidden;
  /*word-break: break-all;111*/
}
.yImg1 {
  width: 69px;
  height: 69px;
  display: block;
  position: absolute;
  top: -35px;
  left: 8%;
}
.yImg {
  width: 100%;
  height: auto;
  display: block;
}

.x_1 {
  width: 79%;
  height: 4px;
  display: block;
  margin-top: 15px;
}
.x_2 {
  width: 19%;
  display: block;
  cursor: pointer;
}
.btn > span {
  display: inline-block;
  line-height: initial;
  font-size: 16px;
  color: #fff;
  background-color: #bda67d;
  border-radius: 6px;
  padding: 15px 30px;
  cursor: pointer;
}
/* 横线按钮 */
.btn_h {
  width: 100%;
  height: 34px;
  display: block;
  position: relative;
  margin-top: 100px;
}
.h_x_1 {
  width: 70%;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #c28e33;
  top: 18px;
  left: 0;
}
.h_x_2 {
  display: block;
  position: absolute;
  top: 2px;
  right: 5%;
  font-size: 22px;
  color: #c28e33;
}
.h_x_3 {
  width: 34px;
  height: 34px;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
}

@media only screen and (max-width: 1440px) {
  .in_abtCnt {
    width: 90%;
  }
}
@media only screen and (max-width: 1024px) {
  .x_1 {
    width: 70%;
    height: 4px;
    margin-top: 15px;
  }
  .x_2 {
    width: 26%;
  }
  .btn_h {
    margin-top: 30px;
  }
  .h_x_1 {
    width: 65%;
  }
}
@media only screen and (max-width: 768px) {
  .ywzs_zs {
    flex-wrap: wrap;
  }
  .ywzs_ls {
    width: 100%;
  }
  .ywzs_ls:nth-child(2) {
    margin: 50px 0 0 0;
  }
  .x_1 {
    width: 60%;
    height: 4px;
    margin-top: 15px;
  }
  .x_2 {
    width: 36%;
  }
  .h_x_1 {
    width: 50%;
  }
}
@media only screen and (max-width: 425px) {
  .ywzs_title {
    font-size: 18px;
    padding: 30px 0;
  }
  .ywzs_js {
    font-size: 14px;
    margin: 0 0 45px 0;
    line-height: 20px;
  }
  .y_txt {
    font-size: 12px;
    line-height: 20px;
    top: 40%;
    width: 104%;
  }
  .btn {
    margin: 66px 0 0 0;
  }
  .x_1 {
    width: 56%;
    height: 2px;
    margin-top: 10px;
  }
  .x_2 {
    width: 40%;
  }
  .yImg {
    height: 170px;
  }
  .h_x_1 {
    width: 46%;
  }
  .h_x_2{
    right: 13%;
    font-size: 16px;
    top: 14%;
  }
  .h_x_3{
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    top: 23%;
    right: 3%;
  }
  .division_i_s{
    height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BusinessIntroduction/component/IntellectualProperty.vue